import React from 'react';
import { useTranslation } from 'react-i18next';
import { Calendar } from 'lucide-react';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';

interface AppointmentItemProps {
  booking: any;
  getPerformanceById: (id: any) => any;
  className?: string;
}

const AppointmentItem: React.FC<AppointmentItemProps> = ({
  booking,
  getPerformanceById,
  className = '',
}) => {
  const { t } = useTranslation();

  // Il nome del servizio è direttamente sulla performance (non esiste un getServiceById nel context)
  const performance = getPerformanceById(booking.performance_id);
  const serviceName = performance?.name || t('bookings.modal.service_not_found', 'Servizio');
  
  const bookingDate = new Date(booking.date);
  const formattedDate = format(bookingDate, 'dd MMM yyyy', { locale: it });
  const formattedTime = booking.time ? booking.time.slice(0, 5) : '';

  let statusLabel = '';
  let statusClass = '';

  switch (booking.status) {
    case 'confirmed':
      statusLabel = t('bookings.status_confirmed', 'Confermato');
      statusClass = 'bg-green-50 text-green-700 border-green-100';
      break;
    case 'no_show':
      statusLabel = t('bookings.status_no_show', 'No-Show');
      statusClass = 'bg-blue-50 text-blue-700 border-blue-100';
      break;
    case 'cancelled':
      statusLabel = t('bookings.status_cancelled', 'Cancellato');
      statusClass = 'bg-red-50 text-red-700 border-red-100';
      break;
    case 'pending':
      statusLabel = t('bookings.status_pending', 'In attesa');
      statusClass = 'bg-amber-50 text-amber-700 border-amber-100';
      break;
    default:
      statusLabel = booking.status || 'Sconosciuto';
      statusClass = 'bg-gray-50 text-gray-700 border-gray-100';
  }

  return (
    <div
      className={`flex items-center justify-between p-3.5 bg-gray-50 border border-gray-100 rounded-xl transition-all ${className}`}
    >
      <div className="flex flex-col gap-1">
        <span className="text-sm font-bold text-gray-800">
          {serviceName}
        </span>
        <span className="text-xs text-gray-500 flex items-center gap-1">
          <Calendar size={12} />
          {formattedDate} alle {formattedTime}
        </span>
      </div>
      <span className={`text-[10px] font-bold px-2.5 py-1 rounded-lg border ${statusClass}`}>
        {statusLabel}
      </span>
    </div>
  );
};

export default AppointmentItem;
